function requireRuntimeEnv(name: 'VITE_API_BASE_URL' | 'VITE_R2_PUBLIC_URL') {
  const value = import.meta.env[name]?.trim()

  if (!value) {
    throw new Error(`Missing required runtime environment variable: ${name}`)
  }

  return value
}

export const API_BASE_URL = requireRuntimeEnv('VITE_API_BASE_URL')
export const R2_PUBLIC_URL = requireRuntimeEnv('VITE_R2_PUBLIC_URL')
export const ENABLE_MSW = import.meta.env.VITE_ENABLE_MSW === 'true'
export const DEFAULT_TENANT = import.meta.env.VITE_DEFAULT_TENANT?.trim() || undefined

// A API na raiz do próprio portal usa o BFF corporativo.
export const SSO_AUTH_MODE = import.meta.env.VITE_AUTH_MODE === 'sso' || API_BASE_URL === '/'
